import { useEffect, useRef } from "react";
import LoadingModal from "components/common/loading/LoadingModal";

import {
  handleLogout,
  redirectToLogin,
  checkIsAuthenticated,
} from "utils/auth";

const Logout = () => {
  const hasTriggeredLogout = useRef(false);

  useEffect(() => {
    if (hasTriggeredLogout.current) return;

    hasTriggeredLogout.current = true;

    if (checkIsAuthenticated()) {
      handleLogout();
      return;
    }

    redirectToLogin();
  }, []);

  return <LoadingModal loadingText="Logging out..." />;
};

export default Logout;
